<template>
    <div>
        <div class="relative w-full aspect-w-6 aspect-h-7 overflow-hidden"
            style="clip-path: url(#PhotographerClipPath);">
            <img alt="photo de Photographer" class="w-full h-full object-cover" :src="image" />
        </div>
        <svg aria-hidden="true" class="absolute w-0 h-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100">
            <clipPath id="PhotographerClipPath" clipPathUnits="objectBoundingBox" transform="scale(0.0173, 0.0133)">
                <path
                    d="M56.2,21.2c-1.7-5.9-4.7-10.6-8.8-14C42.4,2.7,35.9,0,28.7,0c-8,0-15.2,3.4-20.3,8.8c-2.6,2.6-4.7,5.8-6.2,9.7c-4.3,11.3-2.5,21.8,6.1,30.7c6,6.2,20.3,20.6,20.3,20.6s13.9-14.2,19.9-20.1C56.7,41.6,59.2,32,56.2,21.2z" />
            </clipPath>
        </svg>
    </div>
</template>

<script>
export default {
    name: "Photographer",
    props: ["image"],
};
</script>
